export default __webpack_public_path__ + "6fbdebde10c526d08e7521d603fdafcb.svg";